<template>
  <div class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <path
        class="arrow"
        d="M95.8 45.7c2.4 1.2 3.3 4.2 2 6.5-.5.9-1.2 1.6-2 2L9.5 99.4c-2.4 1.2-5.3.3-6.5-2-.4-.7-.6-1.5-.6-2.2V4.8C2.5 2.2 4.6 0 7.3 0c.8 0 1.6.2 2.2.6l86.3 45.1z" />
    </svg>
  </div>
</template>
